export default "__VITE_ASSET__CHfJY_Ey__"